module.exports = __webpack_public_path__ + "static/media/e&oHead.6df101f0.jpg";